import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

import Tooltip from 'components/Tooltip';

import { __t, applyTranslations } from 'utils/language';

import './tile-standard-header-details-locations.scss';

applyTranslations(require('../../tile-standard-header.i18n.json'));

type Props = {
  locations: Array<string>
};

const MSG_KEY = 'tile_standard_header';

const TileStandardHeaderDetailsLocations = (
  {
    locations
  }: Props
): JSX.Element => {
  const location = {
    item: locations[0],
    tooltip: locations.slice(1)
  };

  return (
    <div className="tile-standard-header-details-locations">
      <div
        className="tile-standard-header-details-locations__label text-overflow-ellipsis"
        title={`${__t(`${MSG_KEY}.labels.location`)}: ${location.item}`}
      >
        {location.item}
      </div>
      {
        !isEmpty(location.tooltip) && (
          <Tooltip
            message={`${location.tooltip.join('<br />')}`}
            width="auto-compact"
          >
            {
              __t(`${MSG_KEY}.labels.location_plus`, {
                count: location.tooltip.length
              })
            }
          </Tooltip>
        )
      }
    </div>
  );
};

export default TileStandardHeaderDetailsLocations;
